import {
  FETCH_NAVIGATION_PENDING,
  FETCH_NAVIGATION_REJECTED,
  FETCH_NAVIGATION_FULFILLED,
  SET_SELECTED_CATEGORY,
} from 'constants/navigation';

import { request } from 'axios/request';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_NAVIGATION_PENDING,
});

const rejected = (error) => ({
  type: FETCH_NAVIGATION_REJECTED,
  error: error,
});

const fulfilled = (response) => ({
  type: FETCH_NAVIGATION_FULFILLED,
  response: response,
});

export const setSelectedCategory = (pk) => (dispatch, getState) => {
  const menuItems = getState().navigation.menuItems;
  const data = menuItems.find((menuItem) => menuItem.pk === pk);
  dispatch({
    type: SET_SELECTED_CATEGORY,
    data,
  });
};

export const fetchMenuItems = () => (dispatch, getState) => {
  dispatch(pending());

  request({ method: 'get', url: `${$U.MENU}` })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/navigation.js